import type { ISxProps } from './types'
import { Popover as MuiPopover } from '@mui/material'

export default function Popover({
  children,
  anchorEl,
  onClose,
  anchorOrigin,
  transformOrigin,
  sx,
}: {
  children: React.ReactNode
  anchorEl: HTMLElement | null
  onClose: () => void
  anchorOrigin: {
    vertical: 'bottom' | 'top'
    horizontal: 'left' | 'right'
  }
  transformOrigin: {
    vertical: 'bottom' | 'top'
    horizontal: 'left' | 'right'
  }
  sx?: ISxProps
}) {
  return (
    <MuiPopover
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      open={Boolean(anchorEl)}
      sx={sx}
    >
      {children}
    </MuiPopover>
  )
}
